

import { useSelector,useDispatch } from 'react-redux'
import { AspectRatio, Box, Grid, createStyles } from '@mantine/core';
import UserShowDoc from '../user/helper/UserShowDoc';
//import UserShowSignDoc from '../user/helper/UserShowSignDoc';
import UserShowSignDocStapel from '../user/helper/UserShowSignDocStapel';
import { setdisplaywidth } from '../slice/mainslice';
import intl from 'react-intl-universal';
import { useEffect, useRef, useState } from 'react';

//let joinlink = "https://join.uc-lab.lilenium.com/meeting/"

const useStyles = createStyles((theme) => ({
  fixedgrid: {
    position: 'fixed',
    top: '82px',
    left: 0,
    zIndex: 100, // Adjust z-index as needed
  },
  fixedgridnoonline: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 100, // Adjust z-index as needed
  },
}));


const VideoView = (props:any) => {
  const dispatch = useDispatch()
  const { classes } = useStyles();
  //const meuser = useSelector((state: any) => state.user.meuser)
  const cmslink = useSelector((state: any) => state.user.cmslink)
  const showdoc = useSelector((state: any) => state.user.showmeetingdocs)
  
  const showsigndoc = useSelector((state: any) => state.user.showsignmeetingdocs)
  const showdocnotar = useSelector((state: any) => state.user.readdocnotaronly)
  const showsigndocstapel = useSelector((state: any) => state.user.showsignmeetingdocsstapel)
  const displaywidth = useSelector((state: any) => state.user.displaywidth)
  const notarhastosign = useSelector((state: any) => state.user.notarhastosign)

  const cmslinkfirstName = useSelector((state: any) => state.user.cmslinkfirstName)
  const cmslinklastName = useSelector((state: any) => state.user.cmslinklastName)

  const [isFixed, setIsFixed] = useState(false);
  const gridRef = useRef<HTMLDivElement>(null); // Ref for the Grid element
  const [gridWidthtop, setGridWidth] = useState(0);

  const showonlinebar = useSelector((state: any) => state.user.showonlinebar)
  const changelanguage = useSelector((state: any) => state.user.changelanguage)

  const temppdfurl = useSelector((state: any) => state.user.temppdfurl)



  // Wenn die  Grid Position am View 0 ist setzte den VideConatiner auf Fixed
  // die Breite wur auf Basis der folgenden Funktion ermittelt
  // Bei Screenbreiten von <= 990px wird der VideoConatiner nicht fixiert
  useEffect(() => {
    const handleScroll = () => {
      if (gridRef.current) {
        const rect = gridRef.current.getBoundingClientRect();
        if (gridWidthtop >= 990 && showdoc.resourceId !== undefined){
         setIsFixed(rect.top <= 0);
        } else {
          setIsFixed(false);
        }
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [gridWidthtop,showdoc.resourceId]);

  // Funktion um die Breite des VideoConatiners zu ermitteln
  // um die richtige Breite des fixierten Videoconatiners zu übergeben
  // Berücksichtigt auch Größen Wechsel des Fensters
  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        setGridWidth(gridRef.current.offsetWidth); 
      }
    };
    if (gridRef.current) {
      setGridWidth(gridRef.current.offsetWidth); 
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  //console.log("changelanguage",changelanguage)

  let intoptions = intl.getInitOptions()

  let languagcode
  if (intoptions.currentLocale === "de_DE"){
    languagcode = "de-DE"
  }
  if (intoptions.currentLocale === "en_US"){
    languagcode = "en-US"
  }
  
  let viewusername = cmslinkfirstName + " " + cmslinklastName
 
  let addtourl ="&name="+viewusername
  let addskip
  
  if (changelanguage){
  addskip = "&skipJoinOptions=true"
  } else {  
  addskip = ""
  }

  //console.log("joinlink",cmslink.joinLink)
  
  let splitjoinlink 
  let joinlink
  let meetingpart
  try {
    if (cmslink !== undefined){
		// joinlink = cmslink.joinLink+addtourl+addskip
     splitjoinlink = cmslink.joinLink.split('meeting/')
     meetingpart = splitjoinlink[1].split('?')
     let languagepart = languagcode+"/meeting/";
     joinlink = splitjoinlink[0]+languagepart+meetingpart[0]+"?secret="+addtourl
    
     
	} else {
		throw new Error ("CMS Link is empty");
	}
  } catch (e) {
	  console.log(e);
    } finally {
	if (joinlink === undefined){
    joinlink = "https://join.uc-lab.lilenium.com/meeting/"
  }
}

let ratio:number = 16 / 9;
let gridwidth = 12



if (showsigndoc.resourceId !== undefined && showdoc.resourceId === undefined && notarhastosign){
  if (displaywidth === 1){
    ratio = 70 / 9;
  }
  if (displaywidth === 2){
    gridwidth = 6;
  }


} 

if (showdoc.resourceId !== undefined){
  if (displaywidth === 1){
    ratio = 70 / 9;
  }
  if (displaywidth === 2){
    gridwidth = 6;
  }
}

if (showsigndocstapel.stapelId !== undefined){
  if (displaywidth === 1){
    ratio = 70 / 9;
  }
  if (displaywidth === 2){
    gridwidth = 6;
  }
}

if (props.showlogs){
  ratio = 70 / 9;
}

if (temppdfurl !== ""){
  ratio = 70 / 9;
}

if (showdocnotar !== ""){
  ratio = 70 / 9;
}


// Check ob ein Dokument angezeigt wird; wenn nein das Fenste wieder auf 100% setzten
if (showsigndoc.resourceId === undefined && showdoc.resourceId === undefined){
  if (displaywidth === 2){
    dispatch(setdisplaywidth(1))
  }
} 

//console.log("temppdfurl",temppdfurl)

  return (
    <>
    
    <Grid ref={gridRef}>
    <Grid.Col span={gridwidth}>
    <div className={isFixed ? (showonlinebar ? classes.fixedgrid : classes.fixedgridnoonline) : ''} style={isFixed ? { width: `${gridWidthtop + 20}px` } : {}}>
    <AspectRatio ratio={ratio} sx={{ maxWidth: 1920 }} mx="auto">
      <iframe
        src={joinlink}
        title={"Testraum"}
        allow="camera;microphone;display-capture"
        allowFullScreen
        frameBorder= "0"
      />
    </AspectRatio> 
    </div>
    </Grid.Col>
    <Grid.Col span={gridwidth}>
    
    {showdocnotar !== "" &&
     <UserShowDoc resourceId={showdocnotar} />
    }

    {showdoc.resourceId !== "" && showdoc.resourceId !== undefined &&
     <UserShowDoc resourceId={showdoc.resourceId} />
    }



    {temppdfurl !== "" && 
           <Box
                                   sx={{
                                     display: 'flex',
                                     justifyContent: 'center',
                                     alignItems: 'center',
                                     width: '100%',
                                   }}
                                 >
                                   <Box
                                     sx={{
                                       width: '100%',
                                       maxWidth: 1920,
                                       position: 'relative',
                                       paddingTop: 'min(56.25%, calc(56.25vw))', // 16:9
                                     }}
                                   >
          <iframe
              src={temppdfurl}
              title={"Testraum"}
              allow="camera;microphone;display-capture"
              allowFullScreen
              frameBorder= "0"
               style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              overflow: 'auto',
                            }}
            />
               </Box>
                              </Box>
    }

</Grid.Col>
</Grid>

    </>
  );
}


export default VideoView ;

 /*<UserShowSignDoc resourceId={showsigndoc.resourceId} />
 
   {showsigndocstapel.stapelId !== undefined && 
       <UserShowSignDocStapel stapelid={showsigndocstapel.stapelId} />
    }
 
 */